import { render, staticRenderFns } from "./MemberCertificateForm.vue?vue&type=template&id=12d77da8"
import script from "./MemberCertificateForm.vue?vue&type=script&lang=js"
export * from "./MemberCertificateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports